export const getStoredRestaurantInfo = () => {
  try {
    return JSON.parse(localStorage.getItem("info")) || {};
  } catch (error) {
    return {};
  }
};

export const isMainPanelRestricted = (restaurantInfo = getStoredRestaurantInfo()) =>
  restaurantInfo?.multiPanel === true && localStorage.getItem("mainPanel") !== "Y";
